const DECIMAL_INPUT_REGEX = /^$|^\d+(?:\.\d{0,6})?$/;

const isDecimalInput = (value) => DECIMAL_INPUT_REGEX.test(value);
const formatQuantity = (value) => (Number.isFinite(Number(value)) ? Number(value).toFixed(2) : "-");

export { isDecimalInput, formatQuantity };
